import { CheckCircle, XCircle, AlertTriangle, Info, X } from 'lucide-react';
import { useApp } from '../context/AppContext';

export function Notifications() {
  const { state, removeNotification } = useApp();

  if (state.notifications.length === 0) {
    return null;
  }

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {state.notifications.map((notification) => {
        const Icon = {
          success: CheckCircle,
          error: XCircle,
          warning: AlertTriangle,
          info: Info,
        }[notification.type];

        const bgColor = {
          success: 'bg-success-50 border-success-200',
          error: 'bg-error-50 border-error-200',
          warning: 'bg-warning-50 border-warning-200',
          info: 'bg-primary-50 border-primary-200',
        }[notification.type];

        const iconColor = {
          success: 'text-success-600',
          error: 'text-error-600',
          warning: 'text-warning-600',
          info: 'text-primary-600',
        }[notification.type];

        const titleColor = {
          success: 'text-success-900',
          error: 'text-error-900',
          warning: 'text-warning-900',
          info: 'text-primary-900',
        }[notification.type];

        return (
          <div
            key={notification.id}
            className={`max-w-sm w-full ${bgColor} border rounded-lg shadow-lg p-4`}
          >
            <div className="flex items-start">
              <Icon className={`h-5 w-5 ${iconColor} mt-0.5`} />
              <div className="ml-3 flex-1">
                <h3 className={`text-sm font-medium ${titleColor}`}>
                  {notification.title}
                </h3>
                {notification.message && (
                  <p className="mt-1 text-sm text-gray-600">
                    {notification.message}
                  </p>
                )}
              </div>
              <button
                onClick={() => removeNotification(notification.id)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
}
